import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import Select from "react-select"
import { SectionContext } from "../../context/sectionContext"
import { ConditionContext } from "../../context/conditionContext"
import { ErrorContext } from "../../context/errorContext"
import { JourneyContext } from "../../context/journeyContext"
import { getValueFromJourney } from "../../services/helperFunctions"
import { lineCapital } from "../../../shared/functions"
import * as keywordMapping from "../../../../static/nvestKeyMapping.json"
import * as lookup from "../../../../static/lookup.json"
import { productRenderChecker } from "../../services/helperFunctions"
import Parser from 'html-react-parser';
import { getAllInputQuotations } from "../../../services/apiservice"
import { errorToastr } from "../../../services/error-handler"

const SelectContainer = styled.div`
  display: block;
  flex-direction: column;
  margin: 14px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;
  min-width: 100%;
  max-width: 100%;

  & > .css-2b097c-container {
    margin-top: -17px;
    
    & div.css-1pahdxg-control{
      background: ${props => props.channel === "A" || props.channel === "28" || props.channel === "35" ? "#ededed" : "#fff"} !important;
      background: var(--lumiq-bg) !important;
    }

    & > div {
      border-radius: 0;
      border: 1px solid #929292;
      padding: 0.6rem 0;
      padding-bottom: 0;
    }

    .css-1uccc91-singleValue{
      color:inherit;
      font-size: 1rem;
    }

    & div.css-yk16xz-control{
      background: ${props => props.channel === "A" || props.channel === "28" || props.channel === "35" ? "#ededed" : "#fff"};
      background: var(--lumiq-bg);

      .css-1hb7zxy-IndicatorsContainer > div{
        padding: 0 !important;        
      }
    }
    .css-1gtu0rj-indicatorContainer{
      padding: 0 !important;
      padding-right: 4px !important;
    }

    & > div.css-26l3qy-menu {
      z-index: 500 !important;
      background: ${props => props.channel === "A" || props.channel === "28" || props.channel === "35" ? "#ededed" : "#fff"};
      background:var(--lumiq-bg)

    }

    & > div {
      box-shadow: none !important;
      border: 1px solid #929292;
    }
    & .css-1okebmr-indicatorSeparator {
      background: transparent;
    }
  }

  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background-color: ${props => props.channel === "A" || props.channel === "28" || props.channel === "35" ? "#ededed" : "#fff"};
    background-color: var(--lumiq-bg);
    padding: 2px 5px;
    z-index: 1;
    position: relative;
    display: inline-block;
    cursor: default;
  }
`

export default function ComponentProductSelect(props) {
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [errorState, setErrorState] = useContext(ErrorContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [options, setOptions] = useState({})

  const validate = (target) => {
    if (props.data.required && options && options[props.data.formControlKey] && Object.keys(options[props.data.formControlKey]).length > 0) {
      if ((sectionState.sectionData[props.data.formControlKey] === "") || (!sectionState.sectionData[props.data.formControlKey])) {
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: (getValueFromJourney(
              journeyState.lookup.required_error,
              props.data.requiredError
            ))
          })
        })
      } else {
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: ""
          })
        })
      }
      if (target.value) {
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: ""
          })
        })
      }
    } else {
      setErrorState(prev => {
        return ({
          ...prev,
          [props.data.formControlKey]: ""
        })
      })
    }
    return
  }

  useEffect(() => {

    if (!sectionState.sectionData?.["GIAPplanOPtion"] && journeyState.journeyIdFromStrapi === "guaranteedIncomeAdvantage") {
      setSectionState((prev) => {
        return ({
          ...prev,
          sectionData: {
            ...prev.sectionData,
            "GIAPplanOPtion": "GIHPTN"
          },
        })
      })
      setConditionState(prev => {
        return {
          ...prev,
          [`${props.pageId}.${props.sectionId}.GIAPplanOPtion`]: "GIHPTN",
        }
      })
    }
  }, [])

  //FOR VALIDATION
  useEffect(() => {
    validate({ value: sectionState.sectionData[props.data.formControlKey] ?? "" })
  }, [sectionState.sectionData[props.data.formControlKey], options[props.data.formControlKey]])

  useEffect(() => {
    let optionsFromLookup = props.options
    console.log(props.nvestFilterResult, "dfdfefe")
    let optionNameInMappingJson = keywordMapping[props.journeyIdFromStrapi][`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]
    let requiredObjectInNvestFilterResult = props.nvestFilterResult?.formInputs.filter(element => element.unified_keywordName === optionNameInMappingJson)
    if (!requiredObjectInNvestFilterResult || !optionNameInMappingJson) {
      if (props.data.getLookupFromJounreyState) {
        if (!Object.keys(journeyState[props.data.journeyStateLookupKey])?.length) {
          setOptions(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: props.nvestFilterResult?.[props.data.journeyStateLookupKey]
            })
          })
        } else {
          setOptions(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: journeyState[props.data.journeyStateLookupKey]
            })
          })
        }
      } else {
        setOptions(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: optionsFromLookup
          })
        })
      }
      if (props.sectionId === "sectionFlexiEdgeCustomizeYourPlan"
        && props.data.formControlKey === "FlexiCPPremiumPaymentTerm") {
        let ptValue = conditionState["PageFlexiEdgeCalculatePremium.sectionFlexiEdgeCustomizeYourPlan.FlexiCPPolicyTerm"]
        if (ptValue) {
          let optionValues = journeyState.optionValues
          if (!Object.keys(optionValues)?.length) {
            if (props.nvestFilterResult) {
              optionValues = props.nvestFilterResult?.["optionIds"]
            } else {
              return
            }
          }
          let optionBasedOnPt = Object.keys(optionValues).find(element => {
            if (optionValues[element].ptValues?.[ptValue]) {
              return element
            }
          })
          console.log("optionBasedOnPt===>", optionBasedOnPt)
          let pptOptions = optionValues[optionBasedOnPt]?.pptValues?.[ptValue]
          setOptions(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: pptOptions
            })
          })
          if (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey]) {
            let selectedOption = Object.keys(pptOptions).find(element => element === sectionState.sectionData[props.data.formControlKey])
            if (!selectedOption) {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionData: {
                    ...prev.sectionData,
                    [props.data.formControlKey]: Object.keys(pptOptions)[0]
                  }
                }
              })
              setConditionState(prev => {
                return {
                  ...prev,
                  [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: Object.keys(pptOptions)[0],
                }
              })

            }
          }
        } else {
          let newOption = {
            "select": "select"
          }
          setOptions(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: newOption
            })
          })
        }
      }
      return
    }
    // console.log(requiredObjectInNvestFilterResult, props.data.formControlKey, "Dfgrgr")
    let parentUnifiedkeyofProposalJSON = requiredObjectInNvestFilterResult?.[0]?.listItems?.[0]?.ParentUnifiedkeyofProposalJSON
    // console.log(parentUnifiedkeyofProposalJSON, props.data.formControlKey, "dfrgthyj")
    //reverseMapping the value
    if (parentUnifiedkeyofProposalJSON) {
      let reverseKey = Object.keys(keywordMapping[props.journeyIdFromStrapi]).find(element => keywordMapping[props.journeyIdFromStrapi][element].toLowerCase() === parentUnifiedkeyofProposalJSON.toLowerCase())
      if (reverseKey) {
        if (conditionState[reverseKey]) {
          let newOptions = {}
          console.log(3333333333333, journeyState)


          requiredObjectInNvestFilterResult?.[0]?.listItems?.map((element, index) => {
            if (productRenderChecker(element.ParentUnifiedCode, conditionState[reverseKey])) {
              if (props.data.formControlKey == "monthlyIncomePayout2" || props.data.formControlKey == "monthlyIncomePayout" || props.data.formControlKey == "iSelect360monthlyIncomePayout2") {
                newOptions = props.options
              }
              else if (requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.Unified_key || requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.unified_key) {
                if (props.pageId === "PageFlexiEdgeCalculatePremium" && props.sectionId === "SectionFlexiEdgeCustomizeYourPlan" && props.data.formControlKey === "planOption") {
                  newOptions[requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.Unified_key?.split(",")?.[0] || requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.unified_key?.split?.[0]] = requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.value
                } else {
                  newOptions[requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.Unified_key || requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.unified_key] = requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.value
                }
              }
            }
          })

          setOptions(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: newOptions
            })
          })
          if (Object.keys(newOptions).length == 0) {
            setSectionState(prev => {
              return {
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.formControlKey]: "",
                },
              }
            })
          }
        } else {
          setOptions(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: []
            })
          })
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "",
            }
          })
          setSectionState(prev => {
            return {
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: ""
              }
            }
          })
        }
      }
    } else {
      let newOptions = []
      requiredObjectInNvestFilterResult?.[0]?.listItems?.map((element, index) => {
        if (requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.Unified_key || requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.unified_key) {
          if (props.pageId === "PageFlexiEdgeCalculatePremium" && props.sectionId === "SectionFlexiEdgeCustomizeYourPlan" && props.data.formControlKey === "planOption") {
            newOptions[requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.Unified_key?.split(",")?.[0] || requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.unified_key?.split?.[0]] = requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.value
          } else {
            newOptions[requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.Unified_key || requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.unified_key] = requiredObjectInNvestFilterResult?.[0]?.listItems?.[index]?.value
          }
        }
      })
      console.log(newOptions, "product is null")
      if (props.data.getLookupFromJounreyState) {
        if (!Object.keys(journeyState[props.data.journeyStateLookupKey])?.length) {
          setOptions(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: props.nvestFilterResult?.[props.data.journeyStateLookupKey]
            })
          })
        } else {
          setOptions(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: journeyState[props.data.journeyStateLookupKey]
            })
          })
        }
      } else {
        setOptions(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: newOptions
          })
        })
      }

    }

  }, [props.nvestFilterResult, conditionState?.[props.watchKey]])


  //UseEffect To autoFill Values
  useEffect(() => {
    autoFill()
  }, [sectionState.sectionData[props.data.formControlKey]])

  //For Titanium Plus PT lookup change
  useEffect(() => {
    if (sectionState.sectionData?.["InvestmentPlanOption"] && props.data.formControlKey === "CFpolicyTerm") {
      let conditionStatePlanOptionKey = "PageTitaniumPlusCalculateFundValue.CFSectionInvestmentDetails.InvestmentPlanOption"
      let optionValues = journeyState.optionValues
      if (!Object.keys(optionValues)?.length) {
        if (props.nvestFilterResult) {
          optionValues = props.nvestFilterResult?.["optionIds"]
        } else {
          return
        }
      }
      if (Object.keys(optionValues).length) {
        let policyTermOptions = optionValues?.[conditionState[conditionStatePlanOptionKey]]?.ptValues
        console.log(policyTermOptions, "policyTermOptions")
        if (policyTermOptions) {
          setOptions(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: policyTermOptions
            })
          })
          if (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey]) {
            let selectedOption = Object.keys(policyTermOptions).find(element => element === sectionState.sectionData[props.data.formControlKey])
            if (!selectedOption) {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionData: {
                    ...prev.sectionData,
                    [props.data.formControlKey]: Object.keys(policyTermOptions)[0]
                  }
                }
              })
              setConditionState(prev => {
                return {
                  ...prev,
                  [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: Object.keys(policyTermOptions)[0],
                }
              })

            } else {
              props.saveApplicationAndCallBi("CFpolicyTerm", sectionState.sectionData?.[props.data.formControlKey])
            }
          }
        }
      }
    }
    else if (sectionState.sectionData?.["InvestmentPlanOption"] && props.data.formControlKey === "CFPremiumPaymentTerm") {
      let conditionStatePlanOptionKey = "PageTitaniumPlusCalculateFundValue.CFSectionInvestmentDetails.InvestmentPlanOption"
      if (!sectionState.sectionData?.["CFpolicyTerm"]) {
        let optionValues = journeyState.allUniquePptValues
        if (!Object.keys(optionValues).length) {
          if (props.nvestFilterResult) {
            optionValues = props.nvestFilterResult?.["allUniquePptValues"]
          } else {
            return
          }
        }
        if (Object.keys(optionValues).length) {
          let premiumTermOptions = optionValues
          console.log(premiumTermOptions, "premiumTermOptions")
          if (premiumTermOptions) {
            setOptions(prev => {
              return ({
                ...prev,
                [props.data.formControlKey]: premiumTermOptions
              })
            })
          }
        }
      } else {
        if (sectionState.sectionData?.["CFPremiumPaymentTerm"]) {
          props.saveApplicationAndCallBi("CFPremiumPaymentTerm", sectionState.sectionData?.[props.data.formControlKey])
        }
      }
    }
  }, [sectionState.sectionData?.["InvestmentPlanOption"], props.nvestFilterResult])

  useEffect(() => {
    if (sectionState.sectionData?.["CFpolicyTerm"] && props.data.formControlKey === "CFPremiumPaymentTerm") {
      let conditionStatePlanOptionKey = "PageTitaniumPlusCalculateFundValue.CFSectionInvestmentDetails.InvestmentPlanOption"
      let optionValues = journeyState.optionValues
      if (!Object.keys(optionValues)?.length) {
        if (props.nvestFilterResult) {
          optionValues = props.nvestFilterResult?.["optionIds"]
        } else {
          return
        }
      }
      if (Object.keys(optionValues).length) {
        let premiumPaymentTermOptions = optionValues?.[conditionState[conditionStatePlanOptionKey]]?.pptValues[sectionState.sectionData["CFpolicyTerm"]]
        console.log(premiumPaymentTermOptions, "premiumPaymentTermOptions")
        if (premiumPaymentTermOptions) {
          setOptions(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: premiumPaymentTermOptions
            })
          })
        }
        if (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey] && premiumPaymentTermOptions && Object.keys(premiumPaymentTermOptions)?.length) {
          let selectedOption = Object.keys(premiumPaymentTermOptions).find(element => element === sectionState.sectionData[props.data.formControlKey])
          if (!selectedOption) {
            setSectionState(prev => {
              return {
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.formControlKey]: Object.keys(premiumPaymentTermOptions)[0]
                }
              }
            })
            setConditionState(prev => {
              return {
                ...prev,
                [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: Object.keys(premiumPaymentTermOptions)[0],
              }
            })
            props.saveApplicationAndCallBi("CFPremiumPaymentTerm", Object.keys(premiumPaymentTermOptions)[0])
          } else {
            props.saveApplicationAndCallBi("CFPremiumPaymentTerm", sectionState.sectionData?.[props.data.formControlKey])
          }

        }
      }
    }
  }, [sectionState.sectionData?.["CFpolicyTerm"], props.nvestFilterResult])

  //alpha wealth Plan
  useEffect(() => {
    if (sectionState.sectionData?.["FutureDollarInvestmentPlanOption"] && props.data.formControlKey === "FutureDollarPT") {
      let conditionStatePlanOptionKey = "PageFutureDollarGiftCityCalculateFundValue.FutureDollarGiftCityInvestmentDetailsSection.FutureDollarInvestmentPlanOption"
      let optionValues = journeyState.optionValues
      if (!Object.keys(optionValues)?.length) {
        if (props.nvestFilterResult) {
          optionValues = props.nvestFilterResult?.["optionIds"]
        } else {
          return
        }
      }
      if (Object.keys(optionValues).length) {
        let policyTermOptions = optionValues?.[conditionState[conditionStatePlanOptionKey]]?.ptValues
        console.log(policyTermOptions, "policyTermOptions")
        if (policyTermOptions) {
          setOptions(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: policyTermOptions
            })
          })
          if (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey]) {
            let selectedOption = Object.keys(policyTermOptions).find(element => element === sectionState.sectionData[props.data.formControlKey])
            if (!selectedOption) {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionData: {
                    ...prev.sectionData,
                    [props.data.formControlKey]: Object.keys(policyTermOptions)[0]
                  }
                }
              })
              setConditionState(prev => {
                return {
                  ...prev,
                  [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: Object.keys(policyTermOptions)[0],
                }
              })

            } else {
              props.saveApplicationAndCallBi("FutureDollarPT", sectionState.sectionData?.[props.data.formControlKey])
            }
          }
        }
      }
    }
    else if (sectionState.sectionData?.["FutureDollarInvestmentPlanOption"] && props.data.formControlKey === "FutureDollarPPT") {
      let conditionStatePlanOptionKey = "PageFutureDollarGiftCityCalculateFundValue.FutureDollarGiftCityInvestmentDetailsSection.FutureDollarInvestmentPlanOption"
      if (!sectionState.sectionData?.["FutureDollarPT"]) {
        let optionValues = journeyState.allUniquePptValues
        if (!Object.keys(optionValues).length) {
          if (props.nvestFilterResult) {
            optionValues = props.nvestFilterResult?.["allUniquePptValues"]
          } else {
            return
          }
        }
        if (Object.keys(optionValues).length) {
          let premiumTermOptions = optionValues
          console.log(premiumTermOptions, "premiumTermOptions")
          if (premiumTermOptions) {
            setOptions(prev => {
              return ({
                ...prev,
                [props.data.formControlKey]: premiumTermOptions
              })
            })
          }
        }
      } else {
        if (sectionState.sectionData?.["FutureDollarPPT"]) {
          props.saveApplicationAndCallBi("FutureDollarPPT", sectionState.sectionData?.[props.data.formControlKey])
        }
      }
    }
    else if(sectionState.sectionData?.["FutureDollarInvestmentPlanOption"] && sectionState.sectionData?.["FutureDollarInvestmentPlanOption"] === "ULGCP3" && props.data.formControlKey === "FutureDollarPaymentFrequency"){
      let temp = journeyState?.journeySteps
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === props?.pageId)
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === props?.sectionId)
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "FutureDollarPaymentFrequency")
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "FutureDollarPaymentFrequency")
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = null
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "premiumFrequency_FutureDollar_without_singlePremium"
      setJourneyState(prev => {
        return ({
          ...prev,
          journeySteps: temp
        })
      })
    }
  }, [sectionState.sectionData?.["FutureDollarInvestmentPlanOption"], props.nvestFilterResult])

  useEffect(() => {
    if (sectionState.sectionData?.["FutureDollarPT"] && props.data.formControlKey === "FutureDollarPPT") {
      let conditionStatePlanOptionKey = "PageFutureDollarGiftCityCalculateFundValue.FutureDollarGiftCityInvestmentDetailsSection.FutureDollarInvestmentPlanOption"
      let optionValues = journeyState.optionValues
      if (!Object.keys(optionValues)?.length) {
        if (props.nvestFilterResult) {
          optionValues = props.nvestFilterResult?.["optionIds"]
        } else {
          return
        }
      }
      if (Object.keys(optionValues).length) {
        let premiumPaymentTermOptions = optionValues?.[conditionState[conditionStatePlanOptionKey]]?.pptValues[sectionState.sectionData["FutureDollarPT"]]
        console.log(premiumPaymentTermOptions, "premiumPaymentTermOptions")
        if (premiumPaymentTermOptions) {
          setOptions(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: premiumPaymentTermOptions
            })
          })
        }
        if (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey] && premiumPaymentTermOptions && Object.keys(premiumPaymentTermOptions)?.length) {
          let selectedOption = Object.keys(premiumPaymentTermOptions).find(element => element === sectionState.sectionData[props.data.formControlKey])
          if (!selectedOption) {
            setSectionState(prev => {
              return {
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.formControlKey]: Object.keys(premiumPaymentTermOptions)[0]
                }
              }
            })
            setConditionState(prev => {
              return {
                ...prev,
                [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: Object.keys(premiumPaymentTermOptions)[0],
              }
            })
            props.saveApplicationAndCallBi("FutureDollarPPT", Object.keys(premiumPaymentTermOptions)[0])
          } else {
            props.saveApplicationAndCallBi("FutureDollarPPT", sectionState.sectionData?.[props.data.formControlKey])
          }

        }
      }
    }
  }, [sectionState.sectionData?.["FutureDollarPT"], props.nvestFilterResult])

  useEffect(() => {
    if (props.sectionId === "FutureDollarGiftCityInvestmentDetailsSection" && sectionState?.sectionData?.['FutureDollarPaymentFrequency'] === "SG" ) {
      let temp = journeyState?.journeySteps
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === props?.pageId)
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === props?.sectionId)
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "FutureDollarPPT")
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "FutureDollarPPT")
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = null

      setJourneyState(prev => {
        return ({
          ...prev,
          journeySteps: temp
        })
      })
      setSectionState(prev => {
        return ({
          ...prev,
          sectionData: {
            ...prev.sectionData,
            FutureDollarPPT: "1",
            FutureDollarPaymentFrequency:"SG"
          },
        })
      })
    }
    else if (props.sectionId === "FutureDollarGiftCityInvestmentDetailsSection" && sectionState?.sectionData?.['FutureDollarPaymentFrequency'] !== "SG" ) {

      let temp = journeyState?.journeySteps
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === props?.pageId)
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === props?.sectionId)
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "FutureDollarPPT")
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "FutureDollarPPT")
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = null

      setJourneyState(prev => {
        return ({
          ...prev,
          journeySteps: temp
        })
      })
  
    }
  }, [sectionState?.sectionData?.['FutureDollarPaymentFrequency']])

  useEffect(() => {
    if (props.sectionId === "FutureDollarGiftCityInvestmentDetailsSection" && sectionState?.sectionData?.['FutureDollarPPT'] === "1" ) {
      let temp = journeyState?.journeySteps
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === props?.pageId)
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === props?.sectionId)
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "FutureDollarPaymentFrequency")
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "FutureDollarPaymentFrequency")
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
      // temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookup"] = "premiumFrequency_FutureDollar_only_singlePremium"

      setJourneyState(prev => {
        return ({
          ...prev,
          journeySteps: temp
        })
      })
      setSectionState(prev => {
        return ({
          ...prev,
          sectionData: {
            ...prev.sectionData,
            FutureDollarPPT: "1",
            FutureDollarPaymentFrequency:"SG"
          },
        })
      })
    }
    else if(props.sectionId === "FutureDollarGiftCityInvestmentDetailsSection" && sectionState?.sectionData?.['FutureDollarPPT'] !== "1" ) {
      let temp = journeyState?.journeySteps
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === props?.pageId)
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === props?.sectionId)
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "FutureDollarPaymentFrequency")
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "FutureDollarPaymentFrequency")
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = null
      // temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookup"] = "premiumFrequency_FutureDollar_without_singlePremium"

      setJourneyState(prev => {
        return ({
          ...prev,
          journeySteps: temp
        })
      })
    }
  },[sectionState.sectionData?.["FutureDollarPPT"]])


  //For invest 4G Plus PT lookup change
  useEffect(() => {
    if (sectionState.sectionData?.["Invest4gInvestmentPlanOption"] && props.data.formControlKey === "invest4GPT") {
      let conditionStatePlanOptionKey = "PageInvest4GCalculateFundValue.SectionInvest4GInvestmentDetails.Invest4gInvestmentPlanOption"
      let optionValues = journeyState.optionValues
      if (!Object.keys(optionValues)?.length) {
        if (props.nvestFilterResult) {
          optionValues = props.nvestFilterResult?.["optionIds"]
        } else {
          return
        }
      }
      if (Object.keys(optionValues).length) {
        let policyTermOptions = optionValues?.[conditionState[conditionStatePlanOptionKey]]?.ptValues
        console.log(policyTermOptions, "policyTermOptions")
        if (policyTermOptions) {
          setOptions(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: policyTermOptions
            })
          })
          if (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey]) {
            let selectedOption = Object.keys(policyTermOptions).find(element => element === sectionState.sectionData[props.data.formControlKey])
            if (!selectedOption) {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionData: {
                    ...prev.sectionData,
                    [props.data.formControlKey]: Object.keys(policyTermOptions)[0]
                  }
                }
              })
              setConditionState(prev => {
                return {
                  ...prev,
                  [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: Object.keys(policyTermOptions)[0],
                }
              })

            } else {
              props.saveApplicationAndCallBi("invest4GPT", sectionState.sectionData?.[props.data.formControlKey])
            }
          }
        }
      }
    }
    else if (sectionState.sectionData?.["Invest4gInvestmentPlanOption"] && props.data.formControlKey === "invest4GPPT") {
      let conditionStatePlanOptionKey = "PageInvest4GCalculateFundValue.SectionInvest4GInvestmentDetails.Invest4gInvestmentPlanOption"
      if (!sectionState.sectionData?.["invest4GPT"]) {
        let optionValues = journeyState.allUniquePptValues
        if (!Object.keys(optionValues).length) {
          if (props.nvestFilterResult) {
            optionValues = props.nvestFilterResult?.["allUniquePptValues"]
          } else {
            return
          }
        }
        if (Object.keys(optionValues).length) {
          let premiumTermOptions = optionValues
          console.log(premiumTermOptions, "premiumTermOptions")
          if (premiumTermOptions) {
            setOptions(prev => {
              return ({
                ...prev,
                [props.data.formControlKey]: premiumTermOptions
              })
            })
          }
        }
      } else {
        if (sectionState.sectionData?.["invest4GPT"]) {
          props.saveApplicationAndCallBi("invest4GPT", sectionState.sectionData?.[props.data.formControlKey])
        }
      }
    }
  }, [sectionState.sectionData?.["Invest4gInvestmentPlanOption"], props.nvestFilterResult])

  useEffect(() => {
    if (sectionState.sectionData?.["invest4GPT"] && props.data.formControlKey === "invest4GPPT") {
      let conditionStatePlanOptionKey = "PageInvest4GCalculateFundValue.SectionInvest4GInvestmentDetails.Invest4gInvestmentPlanOption"
      let optionValues = journeyState.optionValues
      if (!Object.keys(optionValues)?.length) {
        if (props.nvestFilterResult) {
          optionValues = props.nvestFilterResult?.["optionIds"]
        } else {
          return
        }
      }
      if (Object.keys(optionValues).length) {
        let premiumPaymentTermOptions = optionValues?.[conditionState[conditionStatePlanOptionKey]]?.pptValues[sectionState.sectionData["invest4GPT"]]
        console.log(premiumPaymentTermOptions, "premiumPaymentTermOptions")
        if (premiumPaymentTermOptions) {
          setOptions(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: premiumPaymentTermOptions
            })
          })
        }
        if (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey] && premiumPaymentTermOptions && Object.keys(premiumPaymentTermOptions)?.length) {
          let selectedOption = Object.keys(premiumPaymentTermOptions).find(element => element === sectionState.sectionData[props.data.formControlKey])
          if (!selectedOption) {
            setSectionState(prev => {
              return {
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.formControlKey]: Object.keys(premiumPaymentTermOptions)[0]
                }
              }
            })
            setConditionState(prev => {
              return {
                ...prev,
                [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: Object.keys(premiumPaymentTermOptions)[0],
              }
            })
            props.saveApplicationAndCallBi("invest4GPPT", Object.keys(premiumPaymentTermOptions)[0])
          } else {
            props.saveApplicationAndCallBi("invest4GPPT", sectionState.sectionData?.[props.data.formControlKey])
          }

        }
      }
    }
  }, [sectionState.sectionData?.["invest4GPT"], props.nvestFilterResult])

  //for GSP planOption
  useEffect(() => {
      if(journeyState.planOptionList && props.sectionId === "SectionGuaranteedSavingsChooseGuranteedSum"){ 
        setOptions(prev => {
          return ({
            ...prev,
            ["GSPPlanOPtion"]: journeyState.planOptionList
          })
        })
      }
  }, [])

  //For GSP PT lookup change
  useEffect(() => {
    if (sectionState.sectionData?.["GSPPlanOPtion"]) {
      if (sectionState.sectionData?.["GSPPlanOPtion"] && props.data.formControlKey === "GSPPolicyTerm") {
        let conditionStatePlanOptionKey = "PageGuaranteedSavingsCalculatePremium.SectionGuaranteedSavingsChooseGuranteedSum.GSPPlanOPtion"
        let optionValues = journeyState.optionValues
        if (!Object.keys(optionValues)?.length) {
          if (props.nvestFilterResult) {
            optionValues = props.nvestFilterResult?.["optionIds"]
          } else {
            return
          }
        }
        if (Object.keys(optionValues).length) {
          let policyTermOptions = optionValues?.[conditionState[conditionStatePlanOptionKey]]?.ptValues
          console.log(policyTermOptions, "policyTermOptions")
          if (policyTermOptions) {
            setOptions(prev => {
              return ({
                ...prev,
                [props.data.formControlKey]: policyTermOptions
              })
            })
            if (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey]) {
              let selectedOption = Object.keys(policyTermOptions).find(element => element === sectionState.sectionData[props.data.formControlKey])
              if (!selectedOption) {
                setSectionState(prev => {
                  return {
                    ...prev,
                    sectionData: {
                      ...prev.sectionData,
                      [props.data.formControlKey]: Object.keys(policyTermOptions)[0]
                    }
                  }
                })
                setConditionState(prev => {
                  return {
                    ...prev,
                    [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: Object.keys(policyTermOptions)[0],
                  }
                })

              }
            }
          }
        }
      }
      else if (sectionState.sectionData?.["GSPPlanOPtion"] && props.data.formControlKey === "GSPPremiumPolicyTerm") {
        let conditionStatePlanOptionKey = "PageGuaranteedSavingsCalculatePremium.SectionGuaranteedSavingsChooseGuranteedSum.GSPPlanOPtion"
        if (!sectionState.sectionData?.["GSPPolicyTerm"]) {
          let optionValues = journeyState.optionValues
          if (!Object.keys(optionValues).length) {
            if (props.nvestFilterResult) {
              optionValues = props.nvestFilterResult?.["optionIds"]
            } else {
              return
            }
          }
          if (Object.keys(optionValues).length) {
            let premiumTermOptions = optionValues?.[conditionState[conditionStatePlanOptionKey]]?.ptValues
            console.log(premiumTermOptions, "premiumTermOptions")
            if (premiumTermOptions) {
              setOptions(prev => {
                return ({
                  ...prev,
                  [props.data.formControlKey]: premiumTermOptions
                })
              })
            }
          }
        }
      }
    } else {
      if (props.data.formControlKey === "GSPPolicyTerm" || props.data.formControlKey === "GSPPremiumPolicyTerm") {
        let optionValues
        if (props.data.formControlKey === "GSPPolicyTerm") {
          optionValues = journeyState.allUniquePtValues
        } else if (props.data.formControlKey === "GSPPremiumPolicyTerm") {
          optionValues = journeyState.allUniquePptValues
        } else {
          return
        }
        if (!Object.keys(optionValues)?.length) {
          if (props.nvestFilterResult) {
            if (props.data.formControlKey === "GSPPolicyTerm") {
              optionValues = props.nvestFilterResult?.["allUniquePtValues"]
            } else if (props.data.formControlKey === "GSPPremiumPolicyTerm") {
              optionValues = props.nvestFilterResult?.["allUniquePptValues"]
            }
          } else {
            return
          }
        }
        setOptions(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: optionValues
          })
        })

      }
    }

  }, [sectionState.sectionData?.["GSPPlanOPtion"], props.nvestFilterResult])

  useEffect(() => {
    if (sectionState.sectionData?.["GSPPolicyTerm"] && props.data.formControlKey === "GSPPremiumPolicyTerm") {
      let conditionStatePlanOptionKey = "PageGuaranteedSavingsCalculatePremium.SectionGuaranteedSavingsChooseGuranteedSum.GSPPlanOPtion"
      let optionValues = journeyState.optionValues
      if (!Object.keys(optionValues)?.length) {
        if (props.nvestFilterResult) {
          optionValues = props.nvestFilterResult?.["optionIds"]
        } else {
          return
        }
      }
      if (Object.keys(optionValues).length) {
        let premiumPaymentTermOptions = optionValues?.[conditionState[conditionStatePlanOptionKey]]?.pptValues[sectionState.sectionData["GSPPolicyTerm"]]
        console.log(premiumPaymentTermOptions, "premiumPaymentTermOptions")
        if (premiumPaymentTermOptions) {
          setOptions(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: premiumPaymentTermOptions
            })
          })
        }
        if (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey] && premiumPaymentTermOptions && Object.keys(premiumPaymentTermOptions)?.length) {
          let selectedOption = Object.keys(premiumPaymentTermOptions).find(element => element === sectionState.sectionData[props.data.formControlKey])
          if (!selectedOption) {
            setSectionState(prev => {
              return {
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.formControlKey]: Object.keys(premiumPaymentTermOptions)[0]
                }
              }
            })
            setConditionState(prev => {
              return {
                ...prev,
                [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: Object.keys(premiumPaymentTermOptions)[0],
              }
            })
          }

        }
      }
    }
  }, [sectionState.sectionData?.["GSPPolicyTerm"], props.nvestFilterResult])

  //For JeevanNivesh PT lookup change
  useEffect(() => {
    if (sectionState.sectionData?.["JeevanNiveshPlanOption"]) {
      if (sectionState.sectionData?.["JeevanNiveshPlanOption"] && props.data.formControlKey === "JeevanNiveshPolicyTerm") {
        let conditionStatePlanOptionKey = "PageJeevenNiveshCalculatePremium.SectionJeevanNiveshChooseYourGuaranteedSumAssured.JeevanNiveshPlanOption"
        let optionValues = journeyState.optionValues
        if (!Object.keys(optionValues)?.length) {
          if (props.nvestFilterResult) {
            optionValues = props.nvestFilterResult?.["optionIds"]
          } else {
            return
          }
        }
        if (Object.keys(optionValues).length) {
          let policyTermOptions = optionValues?.[conditionState[conditionStatePlanOptionKey]]?.ptValues
          console.log(policyTermOptions, "policyTermOptions")
          if (policyTermOptions) {
            setOptions(prev => {
              return ({
                ...prev,
                [props.data.formControlKey]: policyTermOptions
              })
            })
            if (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey]) {
              let selectedOption = Object.keys(policyTermOptions).find(element => element === sectionState.sectionData[props.data.formControlKey])
              if (!selectedOption) {
                setSectionState(prev => {
                  return {
                    ...prev,
                    sectionData: {
                      ...prev.sectionData,
                      [props.data.formControlKey]: Object.keys(policyTermOptions)[0]
                    }
                  }
                })
                setConditionState(prev => {
                  return {
                    ...prev,
                    [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: Object.keys(policyTermOptions)[0],
                  }
                })

              }
            }
          }
        }
      }
      else if (sectionState.sectionData?.["JeevanNiveshPlanOption"] && props.data.formControlKey === "JeevanNiveshPremiumPolicyTerm") {
        let conditionStatePlanOptionKey = "PageJeevenNiveshCalculatePremium.SectionJeevanNiveshChooseYourGuaranteedSumAssured.JeevanNiveshPlanOption"
        if (!sectionState.sectionData?.["JeevanNiveshPolicyTerm"]) {
          let optionValues = journeyState.optionValues
          if (!Object.keys(optionValues).length) {
            if (props.nvestFilterResult) {
              optionValues = props.nvestFilterResult?.["optionIds"]
            } else {
              return
            }
          }
          if (Object.keys(optionValues).length) {
            let premiumTermOptions = optionValues?.[conditionState[conditionStatePlanOptionKey]]?.ptValues
            console.log(premiumTermOptions, "premiumTermOptions")
            if (premiumTermOptions) {
              setOptions(prev => {
                return ({
                  ...prev,
                  [props.data.formControlKey]: premiumTermOptions
                })
              })
            }
          }
        }
      }
    } else {
      if (props.data.formControlKey === "JeevanNiveshPolicyTerm" || props.data.formControlKey === "JeevanNiveshPremiumPolicyTerm") {
        let optionValues
        if (props.data.formControlKey === "JeevanNiveshPolicyTerm") {
          optionValues = journeyState.allUniquePtValues
        } else if (props.data.formControlKey === "JeevanNiveshPremiumPolicyTerm") {
          optionValues = journeyState.allUniquePptValues
        } else {
          return
        }
        if (!Object.keys(optionValues)?.length) {
          if (props.nvestFilterResult) {
            if (props.data.formControlKey === "JeevanNiveshPolicyTerm") {
              optionValues = props.nvestFilterResult?.["allUniquePtValues"]
            } else if (props.data.formControlKey === "JeevanNiveshPremiumPolicyTerm") {
              optionValues = props.nvestFilterResult?.["allUniquePptValues"]
            }
          } else {
            return
          }
        }
        setOptions(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: optionValues
          })
        })

      }
    }

  }, [sectionState.sectionData?.["JeevanNiveshPlanOption"], props.nvestFilterResult])

  useEffect(() => {
    if (sectionState.sectionData?.["JeevanNiveshPolicyTerm"] && props.data.formControlKey === "JeevanNiveshPremiumPolicyTerm") {
      let conditionStatePlanOptionKey = "PageJeevenNiveshCalculatePremium.SectionJeevanNiveshChooseYourGuaranteedSumAssured.JeevanNiveshPlanOption"
      let optionValues = journeyState.optionValues
      if (!Object.keys(optionValues)?.length) {
        if (props.nvestFilterResult) {
          optionValues = props.nvestFilterResult?.["optionIds"]
        } else {
          return
        }
      }
      if (Object.keys(optionValues).length) {
        let premiumPaymentTermOptions = optionValues?.[conditionState[conditionStatePlanOptionKey]]?.pptValues[sectionState.sectionData["JeevanNiveshPolicyTerm"]]
        console.log(premiumPaymentTermOptions, "premiumPaymentTermOptions")
        if (premiumPaymentTermOptions) {
          setOptions(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: premiumPaymentTermOptions
            })
          })
        }
        if (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey] && premiumPaymentTermOptions && Object.keys(premiumPaymentTermOptions)?.length) {
          let selectedOption = Object.keys(premiumPaymentTermOptions).find(element => element === sectionState.sectionData[props.data.formControlKey])
          if (!selectedOption) {
            setSectionState(prev => {
              return {
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.formControlKey]: Object.keys(premiumPaymentTermOptions)[0]
                }
              }
            })
            setConditionState(prev => {
              return {
                ...prev,
                [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: Object.keys(premiumPaymentTermOptions)[0],
              }
            })
          }

        }
      }
    }
  }, [sectionState.sectionData?.["JeevanNiveshPolicyTerm"], props.nvestFilterResult])

  //For GIAP Lookup Change
  useEffect(() => {
    if (sectionState.sectionData?.["GIAPPolicyTerm"] && props.data.formControlKey === "GIAPPremiumPaymentTerm") {
      let conditionStatePlanOptionKey = "PageGuaranteedIncomeAdvantageCalculatePremium.SectionGuaranteedIncomeChooseGuaranteedSumAssured.GIAPplanOPtion"
      let optionValues = journeyState.optionValues
      if (!Object.keys(optionValues)?.length) {
        if (props.nvestFilterResult) {
          optionValues = props.nvestFilterResult?.["optionIds"]
        } else {
          return
        }
      }
      if (Object.keys(optionValues).length) {
        let premiumPaymentTermOptions = optionValues?.[conditionState[conditionStatePlanOptionKey]]?.pptValues[sectionState.sectionData["GIAPPolicyTerm"]]
        console.log(premiumPaymentTermOptions, "premiumPaymentTermOptions")
        if (premiumPaymentTermOptions) {
          setOptions(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: premiumPaymentTermOptions
            })
          })
        }
        if (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey] && premiumPaymentTermOptions && Object.keys(premiumPaymentTermOptions)?.length) {
          let selectedOption = Object.keys(premiumPaymentTermOptions).find(element => element === sectionState.sectionData[props.data.formControlKey])
          if (!selectedOption) {
            setSectionState(prev => {
              return {
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.formControlKey]: Object.keys(premiumPaymentTermOptions)[0]
                }
              }
            })
            setConditionState(prev => {
              return {
                ...prev,
                [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: Object.keys(premiumPaymentTermOptions)[0],
              }
            })
          }

        }
      }
    }
  }, [sectionState.sectionData?.["GIAPPolicyTerm"], props.nvestFilterResult])

  // SMART JUNIOR useEffect Hook & Helper Function
  useEffect(() => {
    if (sectionState.sectionData?.["childsFuture"] === "N") {
      if (props.data.formControlKey === "PTsmartJunior") {
        // let conditionStatePlanOptionKey = "PageJeevenNiveshCalculatePremium.SectionJeevanNiveshChooseYourGuaranteedSumAssured.JeevanNiveshPlanOption"
        let optionValues = journeyState.optionValues
        if (!Object.keys(optionValues)?.length) {
          if (props.nvestFilterResult) {
            optionValues = props.nvestFilterResult?.["optionIds"]
          } else {
            return
          }
        }
        if (Object.keys(optionValues).length) {
          let policyTermOptions = optionValues?.["SMJNA1"]?.ptValues
          console.log(policyTermOptions, "policyTermOptions")
          if (policyTermOptions) {
            setOptions(prev => {
              return ({
                ...prev,
                [props.data.formControlKey]: policyTermOptions
              })
            })
            if (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey]) {
              let selectedOption = Object.keys(policyTermOptions).find(element => element === sectionState.sectionData[props.data.formControlKey])
              if (!selectedOption) {
                setSectionState(prev => {
                  return {
                    ...prev,
                    sectionData: {
                      ...prev.sectionData,
                      [props.data.formControlKey]: Object.keys(policyTermOptions)[0]
                    }
                  }
                })
                setConditionState(prev => {
                  return {
                    ...prev,
                    [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: Object.keys(policyTermOptions)[0],
                  }
                })

              }
            }
          }
        }
      }
      else if (props.data.formControlKey === "PPTsmartJunior") {
        // let conditionStatePlanOptionKey = "PageJeevenNiveshCalculatePremium.SectionJeevanNiveshChooseYourGuaranteedSumAssured.JeevanNiveshPlanOption"
        if (!sectionState.sectionData?.["PTsmartJunior"]) {
          let optionValues = journeyState.optionValues
          if (!Object.keys(optionValues).length) {
            if (props.nvestFilterResult) {
              optionValues = props.nvestFilterResult?.["optionIds"]
            } else {
              return
            }
          }
          if (Object.keys(optionValues).length) {
            let premiumTermOptions = optionValues?.["SMJNA1"]?.ptValues
            console.log(premiumTermOptions, "premiumTermOptions")
            if (premiumTermOptions) {
              setOptions(prev => {
                return ({
                  ...prev,
                  [props.data.formControlKey]: premiumTermOptions
                })
              })
            }
          }

        }


      }
    } else {
      if (props.data.formControlKey === "PTsmartJunior" || props.data.formControlKey === "PPTsmartJunior") {
        let optionValues
        if (props.data.formControlKey === "PTsmartJunior") {
          optionValues = journeyState.allUniquePtValues
        } else if (props.data.formControlKey === "PPTsmartJunior") {
          optionValues = journeyState.allUniquePptValues
        } else {
          return
        }
        if (!Object.keys(optionValues)?.length) {
          if (props.nvestFilterResult) {
            if (props.data.formControlKey === "PTsmartJunior") {
              optionValues = props.nvestFilterResult?.["allUniquePtValues"]
            } else if (props.data.formControlKey === "PPTsmartJunior") {
              optionValues = props.nvestFilterResult?.["allUniquePptValues"]
            }
          } else {
            return
          }
        }
        setOptions(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: optionValues
          })
        })
        if (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey]) {
          let selectedOption = Object.keys(optionValues).find(element => element === sectionState.sectionData[props.data.formControlKey])
          if (!selectedOption) {
            setSectionState(prev => {
              return {
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.formControlKey]: Object.keys(optionValues)[0]
                }
              }
            })
            setConditionState(prev => {
              return {
                ...prev,
                [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: Object.keys(optionValues)[0],
              }
            })
          }
        }
      }
    }
  }, [journeyState?.optionValues, props.nvestFilterResult])

  useEffect(() => {
    if (sectionState.sectionData?.["PTsmartJunior"] && props.data.formControlKey === "PPTsmartJunior") {
      // let conditionStatePlanOptionKey = "PageJeevenNiveshCalculatePremium.SectionJeevanNiveshChooseYourGuaranteedSumAssured.JeevanNiveshPlanOption"
      let optionValues = journeyState.optionValues
      if (!Object.keys(optionValues)?.length) {
        if (props.nvestFilterResult) {
          optionValues = props.nvestFilterResult?.["optionIds"]
        } else {
          return
        }
      }
      if (Object.keys(optionValues).length) {
        let premiumPaymentTermOptions = optionValues?.["SMJNA1"]?.pptValues[sectionState.sectionData["PTsmartJunior"]]
        console.log(premiumPaymentTermOptions, "premiumPaymentTermOptions")
        if (premiumPaymentTermOptions) {
          setOptions(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: premiumPaymentTermOptions
            })
          })
        }
        if (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey] && premiumPaymentTermOptions && Object.keys(premiumPaymentTermOptions)?.length) {
          let selectedOption = Object.keys(premiumPaymentTermOptions).find(element => element === sectionState.sectionData[props.data.formControlKey])
          if (!selectedOption) {
            setSectionState(prev => {
              return {
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.formControlKey]: Object.keys(premiumPaymentTermOptions)[0]
                }
              }
            })
            setConditionState(prev => {
              return {
                ...prev,
                [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: Object.keys(premiumPaymentTermOptions)[0],
              }
            })
          }

        }
      }
    }
  }, [sectionState.sectionData?.["PTsmartJunior"], props.nvestFilterResult])

  // SECURE BHAVISHYA
  useEffect(() => {
    if (sectionState.sectionData?.["secureBhavishyaPaymentFrequency"]) {
      if (props.data.formControlKey === "secureBhavishyaPolicyTerm") {
        let planCodeForFrequency = sectionState.sectionData?.["secureBhavishyaPaymentFrequency"] === "SG" ? "ULAPF2" : "ULAPF1"
        let optionValues = journeyState.optionValues
        console.info("POLICYINPUT", journeyState.optionValues)
        if (!Object.keys(optionValues)?.length) {
          if (props.nvestFilterResult) {
            optionValues = props.nvestFilterResult?.["optionIds"]
          } else {
            return
          }
        }
        if (Object.keys(optionValues).length) {
          let policyTermOptions = optionValues?.[planCodeForFrequency]?.ptValues
          console.log(policyTermOptions, "policyTermOptions")
          if (policyTermOptions) {
            setOptions(prev => {
              return ({
                ...prev,
                [props.data.formControlKey]: policyTermOptions
              })
            })
            if (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey]) {
              let selectedOption = Object.keys(policyTermOptions).find(element => element === sectionState.sectionData[props.data.formControlKey])
              if (!selectedOption) {
                setSectionState(prev => {
                  return {
                    ...prev,
                    sectionData: {
                      ...prev.sectionData,
                      [props.data.formControlKey]: Object.keys(policyTermOptions)[0]
                    }
                  }
                })
                setConditionState(prev => {
                  return {
                    ...prev,
                    [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: Object.keys(policyTermOptions)[0],
                  }
                })

              }
            }
          }
        }
      }
      else if (props.data.formControlKey === "secureBhavishyaPremiumPaymentTerm") {
        let planCodeForFrequency = sectionState.sectionData?.["secureBhavishyaPaymentFrequency"] === "SG" ? "ULAPF2" : "ULAPF1"
        if (!sectionState.sectionData?.["secureBhavishyaPolicyTerm"]) {
          let optionValues = journeyState.optionValues
          if (!Object.keys(optionValues).length) {
            if (props.nvestFilterResult) {
              optionValues = props.nvestFilterResult?.["optionIds"]
            } else {
              return
            }
          }
          if (Object.keys(optionValues).length) {
            let premiumTermOptions = optionValues?.[planCodeForFrequency]?.ptValues
            console.log(premiumTermOptions, "premiumTermOptions")
            if (premiumTermOptions) {
              setOptions(prev => {
                return ({
                  ...prev,
                  [props.data.formControlKey]: premiumTermOptions
                })
              })
            }
          }

        }


      }
    } else {
      if (props.data.formControlKey === "secureBhavishyaPolicyTerm" || props.data.formControlKey === "secureBhavishyaPremiumPaymentTerm") {
        let optionValues
        if (props.data.formControlKey === "secureBhavishyaPolicyTerm") {
          optionValues = journeyState.allUniquePtValues
        } else if (props.data.formControlKey === "secureBhavishyaPremiumPaymentTerm") {
          optionValues = journeyState.allUniquePptValues
        } else {
          return
        }
        if (!Object.keys(optionValues)?.length) {
          if (props.nvestFilterResult) {
            if (props.data.formControlKey === "secureBhavishyaPolicyTerm") {
              optionValues = props.nvestFilterResult?.["allUniquePtValues"]
            } else if (props.data.formControlKey === "secureBhavishyaPremiumPaymentTerm") {
              optionValues = props.nvestFilterResult?.["allUniquePptValues"]
            }
          } else {
            return
          }
        }
        setOptions(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: optionValues
          })
        })
        if (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey]) {
          let selectedOption = Object.keys(optionValues).find(element => element === sectionState.sectionData[props.data.formControlKey])
          if (!selectedOption) {
            setSectionState(prev => {
              return {
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.formControlKey]: Object.keys(optionValues)[0]
                }
              }
            })
            setConditionState(prev => {
              return {
                ...prev,
                [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: Object.keys(optionValues)[0],
              }
            })
          }
        }
      }
    }
  }, [sectionState.sectionData?.["secureBhavishyaPaymentFrequency"], props.nvestFilterResult])

  useEffect(() => {
    if (sectionState.sectionData?.["secureBhavishyaPolicyTerm"] && props.data.formControlKey === "secureBhavishyaPremiumPaymentTerm") {
      // let conditionStatePlanOptionKey = "PageJeevenNiveshCalculatePremium.SectionJeevanNiveshChooseYourGuaranteedSumAssured.JeevanNiveshPlanOption"
      let planCodeForFrequency = sectionState.sectionData?.["secureBhavishyaPaymentFrequency"] === "SG" ? "ULAPF2" : "ULAPF1"
      let optionValues = journeyState.optionValues
      if (!Object.keys(optionValues)?.length) {
        if (props.nvestFilterResult) {
          optionValues = props.nvestFilterResult?.["optionIds"]
        } else {
          return
        }
      }
      if (Object.keys(optionValues).length) {
        let premiumPaymentTermOptions = optionValues?.[planCodeForFrequency]?.pptValues[sectionState.sectionData["secureBhavishyaPolicyTerm"]]
        console.log(premiumPaymentTermOptions, "premiumPaymentTermOptions")
        if (premiumPaymentTermOptions) {
          setOptions(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: premiumPaymentTermOptions
            })
          })
        }
        if (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey] && premiumPaymentTermOptions && Object.keys(premiumPaymentTermOptions)?.length) {
          let selectedOption = Object.keys(premiumPaymentTermOptions).find(element => element === sectionState.sectionData[props.data.formControlKey])
          if (!selectedOption) {
            setSectionState(prev => {
              return {
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.formControlKey]: Object.keys(premiumPaymentTermOptions)[0]
                }
              }
            })
            setConditionState(prev => {
              return {
                ...prev,
                [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: Object.keys(premiumPaymentTermOptions)[0],
              }
            })
          }

        }
      }
    }
  }, [sectionState.sectionData?.["secureBhavishyaPolicyTerm"], props.nvestFilterResult])

  //For GFP PT lookup change
  useEffect(() => {
    if (sectionState.sectionData?.["guaranteedFortunePlanOption"]) {
      if (sectionState.sectionData?.["guaranteedFortunePlanOption"] && props.data.formControlKey === "GFPPolicyTerm") {
        let conditionStatePlanOptionKey = "PageGuaranteedFortuneCalculatePremium.SectionGuaranteedFortuneCustomizeYourPlan.guaranteedFortunePlanOption"
        let optionValues = journeyState.optionValues
        if (!Object.keys(optionValues)?.length) {
          if (props.nvestFilterResult) {
            optionValues = props.nvestFilterResult?.["optionIds"]
          } else {
            return
          }
        }
        if (Object.keys(optionValues).length) {
          let policyTermOptions = optionValues?.[conditionState[conditionStatePlanOptionKey]]?.ptValues
          console.log(policyTermOptions, "policyTermOptions")
          if (policyTermOptions) {
            setOptions(prev => {
              return ({
                ...prev,
                [props.data.formControlKey]: policyTermOptions
              })
            })
            if (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey]) {
              let selectedOption = Object.keys(policyTermOptions).find(element => element === sectionState.sectionData[props.data.formControlKey])
              if (!selectedOption) {
                setSectionState(prev => {
                  return {
                    ...prev,
                    sectionData: {
                      ...prev.sectionData,
                      [props.data.formControlKey]: Object.keys(policyTermOptions)[0]
                    }
                  }
                })
                setConditionState(prev => {
                  return {
                    ...prev,
                    [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: Object.keys(policyTermOptions)[0],
                  }
                })

              }
            }
          }
        }
      }
      else if (sectionState.sectionData?.["guaranteedFortunePlanOption"] && props.data.formControlKey === "GFPPremiumPolicyTerm") {
        let conditionStatePlanOptionKey = "PageGuaranteedFortuneCalculatePremium.SectionGuaranteedFortuneCustomizeYourPlan.guaranteedFortunePlanOption"
        if (!sectionState.sectionData?.["GFPPolicyTerm"]) {
          let optionValues = journeyState.optionValues
          if (!Object.keys(optionValues).length) {
            if (props.nvestFilterResult) {
              optionValues = props.nvestFilterResult?.["optionIds"]
            } else {
              return
            }
          }
          if (Object.keys(optionValues).length) {
            let premiumTermOptions = optionValues?.[conditionState[conditionStatePlanOptionKey]]?.ptValues
            console.log(premiumTermOptions, "premiumTermOptions")
            if (premiumTermOptions) {
              setOptions(prev => {
                return ({
                  ...prev,
                  [props.data.formControlKey]: premiumTermOptions
                })
              })
            }
          }
        }
      }
    } else {
      if (props.data.formControlKey === "GFPPolicyTerm" || props.data.formControlKey === "GFPPremiumPolicyTerm") {
        let optionValues
        if (props.data.formControlKey === "GFPPolicyTerm") {
          optionValues = journeyState.allUniquePtValues
        } else if (props.data.formControlKey === "GFPPremiumPolicyTerm") {
          optionValues = journeyState.allUniquePptValues
        } else {
          return
        }
        if (!Object.keys(optionValues)?.length) {
          if (props.nvestFilterResult) {
            if (props.data.formControlKey === "GFPPolicyTerm") {
              optionValues = props.nvestFilterResult?.["allUniquePtValues"]
            } else if (props.data.formControlKey === "GFPPremiumPolicyTerm") {
              optionValues = props.nvestFilterResult?.["allUniquePptValues"]
            }
          } else {
            return
          }
        }
        setOptions(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: optionValues
          })
        })

      }
    }

  }, [sectionState.sectionData?.["guaranteedFortunePlanOption"], props.nvestFilterResult])

  useEffect(() => {
    if (sectionState.sectionData?.["GFPPolicyTerm"] && props.data.formControlKey === "GFPPremiumPolicyTerm") {
      let conditionStatePlanOptionKey = "PageGuaranteedFortuneCalculatePremium.SectionGuaranteedFortuneCustomizeYourPlan.guaranteedFortunePlanOption"
      let optionValues = journeyState.optionValues
      if (!Object.keys(optionValues)?.length) {
        if (props.nvestFilterResult) {
          optionValues = props.nvestFilterResult?.["optionIds"]
        } else {
          return
        }
      }
      if (Object.keys(optionValues).length) {
        let premiumPaymentTermOptions = optionValues?.[conditionState[conditionStatePlanOptionKey]]?.pptValues[sectionState.sectionData["GFPPolicyTerm"]]
        console.log(premiumPaymentTermOptions, "premiumPaymentTermOptions")
        if (premiumPaymentTermOptions) {
          setOptions(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: premiumPaymentTermOptions
            })
          })
        }
        if (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey] && premiumPaymentTermOptions && Object.keys(premiumPaymentTermOptions)?.length) {
          let selectedOption = Object.keys(premiumPaymentTermOptions).find(element => element === sectionState.sectionData[props.data.formControlKey])
          if (!selectedOption) {
            setSectionState(prev => {
              return {
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.formControlKey]: Object.keys(premiumPaymentTermOptions)[0]
                }
              }
            })
            setConditionState(prev => {
              return {
                ...prev,
                [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: Object.keys(premiumPaymentTermOptions)[0],
              }
            })
          }

        }
      }
    }
  }, [sectionState.sectionData?.["GFPPolicyTerm"], props.nvestFilterResult])

  //For Guaranteed Future PT lookup change
  useEffect(() => {
    if (sectionState.sectionData?.["guaranteedFuturePlanOption"]) {
      let temp = journeyState.journeySteps;

      /**
       * Function to change temporary journeySteps
       * @param {string} pageId 
       * @param {string} sectionId 
       * @param {string} componentGroup 
       * @param {string} componentFormControlKey 
       * @param {string} key 
       * @param {any} value 
       */
      const changeJourneySteps = (pageId, sectionId, componentGroup, componentFormControlKey, key, value) => {
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroup)
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === componentFormControlKey)
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange][key] = value
      }

      // FOR PAYMENT FREQUENCY
      if (sectionState.sectionData["guaranteedFuturePlanOption"] === "IG3TR5") {
        setOptions(prev => ({
          ...prev,
          guaranteedFuturePF: lookup["guaranteedFuturePaymentFrequencyOnlySingle"][0]
        }))
        setSectionState(prev => ({
          ...prev,
          sectionData: {
            ...prev.sectionData,
            guaranteedFuturePF: "SG",
          }
        }))
      } else {
        if (!Object.keys(lookup["guaranteedFuturePaymentFrequencyNoSG"][0]).includes(sectionState.sectionData.guaranteedFuturePF)) {
          setSectionState(prev => ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              guaranteedFuturePF: "",
            }
          }))
        }
        setOptions(prev => ({
          ...prev,
          guaranteedFuturePF: lookup["guaranteedFuturePaymentFrequencyNoSG"][0]
        }))
      }

      if (sectionState.sectionData?.["guaranteedFuturePlanOption"] && props.data.formControlKey === "guaranteedFuturePT") {
        let conditionStatePlanOptionKey = "PageGuaranteedFutureCalculatePremium.SectionGuaranteedFutureSumAssured.guaranteedFuturePlanOption"
        let optionValues = journeyState.optionValues
        if (!Object.keys(optionValues)?.length) {
          if (props.nvestFilterResult) {
            optionValues = props.nvestFilterResult?.["optionIds"]
          } else {
            return
          }
        }
        if (Object.keys(optionValues).length) {
          let policyTermOptions = optionValues?.[conditionState[conditionStatePlanOptionKey]]?.ptValues
          console.info(policyTermOptions, "policyTermOptions")
          if (policyTermOptions) {
            setOptions(prev => {
              return ({
                ...prev,
                [props.data.formControlKey]: policyTermOptions
              })
            })
            if (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey]) {
              let selectedOption = Object.keys(policyTermOptions).find(element => element === sectionState.sectionData[props.data.formControlKey])
              if (!selectedOption) {
                setSectionState(prev => {
                  return {
                    ...prev,
                    sectionData: {
                      ...prev.sectionData,
                      [props.data.formControlKey]: Object.keys(policyTermOptions)[0]
                    }
                  }
                })
                setConditionState(prev => {
                  return {
                    ...prev,
                    [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: Object.keys(policyTermOptions)[0],
                  }
                })
              }
              changeJourneySteps("PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFutureSumAssured", "guaranteedFuturePPT", "guaranteedFuturePPT", "disabled", false)
              if (sectionState.sectionData["guaranteedFuturePlanOption"] === "IG3TR5") {
                setSectionState(prev => {
                  return {
                    ...prev,
                    sectionData: {
                      ...prev.sectionData,
                      ["guaranteedFuturePPT"]: "1"
                    }
                  }
                })
                changeJourneySteps("PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFutureSumAssured", "guaranteedFuturePPT", "guaranteedFuturePPT", "disabled", true)
              }

              setJourneyState(prev => ({
                ...prev,
                journeySteps: temp
              }));
            }
          }
        }
      }
      else if (sectionState.sectionData?.["guaranteedFuturePlanOption"] && props.data.formControlKey === "guaranteedFuturePPT") {
        let conditionStatePlanOptionKey = "PageGuaranteedFutureCalculatePremium.SectionGuaranteedFutureSumAssured.guaranteedFuturePlanOption"
        if (!sectionState.sectionData?.["guaranteedFuturePT"]) {
          let optionValues = journeyState.optionValues
          if (!Object.keys(optionValues).length) {
            if (props.nvestFilterResult) {
              optionValues = props.nvestFilterResult?.["optionIds"]
            } else {
              return
            }
          }
          if (Object.keys(optionValues).length) {
            let premiumTermOptions = optionValues?.[conditionState[conditionStatePlanOptionKey]]?.ptValues
            console.log(premiumTermOptions, "premiumTermOptions")
            if (premiumTermOptions) {
              setOptions(prev => {
                return ({
                  ...prev,
                  [props.data.formControlKey]: premiumTermOptions
                })
              })
            }
          }
        }
      }
    } else {
      if (props.data.formControlKey === "guaranteedFuturePT" || props.data.formControlKey === "guaranteedFuturePPT") {
        let optionValues
        if (props.data.formControlKey === "guaranteedFuturePT") {
          optionValues = journeyState.allUniquePtValues
        } else if (props.data.formControlKey === "guaranteedFuturePPT") {
          optionValues = journeyState.allUniquePptValues
        } else {
          return
        }
        if (!Object.keys(optionValues)?.length) {
          if (props.nvestFilterResult) {
            if (props.data.formControlKey === "guaranteedFuturePT") {
              optionValues = props.nvestFilterResult?.["allUniquePtValues"]
            } else if (props.data.formControlKey === "guaranteedFuturePPT") {
              optionValues = props.nvestFilterResult?.["allUniquePptValues"]
            }
          } else {
            return
          }
        }
        setOptions(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: optionValues
          })
        })

      }
    }
  }, [sectionState.sectionData?.["guaranteedFuturePlanOption"], props.nvestFilterResult])

  useEffect(() => {
    if (sectionState.sectionData?.["guaranteedFuturePT"] && props.data.formControlKey === "guaranteedFuturePPT") {
      let temp = journeyState.journeySteps;
      const changeJourneySteps = (pageId, sectionId, componentGroup, componentFormControlKey, key, value) => {
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroup)
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === componentFormControlKey)
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange][key] = value
      }
      let conditionStatePlanOptionKey = "PageGuaranteedFutureCalculatePremium.SectionGuaranteedFutureSumAssured.guaranteedFuturePlanOption"
      let optionValues = journeyState.optionValues
      if (!Object.keys(optionValues)?.length) {
        if (props.nvestFilterResult) {
          optionValues = props.nvestFilterResult?.["optionIds"]
        } else {
          return
        }
      }
      if (Object.keys(optionValues).length) {
        let premiumPaymentTermOptions = optionValues?.[conditionState[conditionStatePlanOptionKey]]?.pptValues[sectionState.sectionData["guaranteedFuturePT"]]
        console.log(premiumPaymentTermOptions, "premiumPaymentTermOptions")
        if (premiumPaymentTermOptions) {
          setOptions(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: premiumPaymentTermOptions
            })
          })
        }
        changeJourneySteps("PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFutureSumAssured", "guaranteedFuturePPT", "guaranteedFuturePPT", "disabled", false)
        if (sectionState.sectionData["guaranteedFuturePlanOption"] === "IG3TR5") {
          setSectionState(prev => {
            return {
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: "1"
              }
            }
          })
          changeJourneySteps("PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFutureSumAssured", "guaranteedFuturePPT", "guaranteedFuturePPT", "disabled", true)
        } else {
          delete premiumPaymentTermOptions["1"];
          setOptions(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: premiumPaymentTermOptions
            })
          })
          if (Object.keys(premiumPaymentTermOptions).length === 1) {
            const pptValue = Object.keys(premiumPaymentTermOptions)[0];
            setSectionState(prev => {
              return {
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.formControlKey]: pptValue
                }
              }
            })
          }
        }

        setJourneyState(prev => ({
          ...prev,
          journeySteps: temp
        }));

        if (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey] && premiumPaymentTermOptions && Object.keys(premiumPaymentTermOptions)?.length) {
          let selectedOption = Object.keys(premiumPaymentTermOptions).find(element => element === sectionState.sectionData[props.data.formControlKey])
          if (!selectedOption) {
            setSectionState(prev => {
              return {
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.formControlKey]: Object.keys(premiumPaymentTermOptions)[0]
                }
              }
            })
            setConditionState(prev => {
              return {
                ...prev,
                [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: Object.keys(premiumPaymentTermOptions)[0],
              }
            })
          }

        }
      }
    }
  }, [sectionState.sectionData?.["guaranteedFuturePT"], props.nvestFilterResult])

  const autoFill = () => {
    console.log("function called", sectionState)
    if ((props.sectionId === "CPCustomizePlanSection" && props.data.formControlKey === "CPCustomizePlanPaymentFrequency") || (props.sectionId === "iSelect360CPCustomizePlanSection" && props.data.formControlKey === "iSelect360CPCustomizePlanPaymentFrequency")) {

      //Temp Indexes will be used either in if or else
      let temp = journeyState.journeySteps
      let tempPageIndexToChange
      let tempSectionIndexToChange
      let tempComponentGroupIndexToChange
      let tempComponentIndexToChange
      if (props.journeyIdFromStrapi === "iSelectJourney") {
        tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "calculatePremiumPage")
        tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "CPCustomizePlanSection")
        tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "CPCustomizePlan")
        tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "CPCustomizePlanPremiumPaymentTerm")
      } else if (props.journeyIdFromStrapi === "ISelect360Journey") {
        tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageISelect360CalculatePremium")
        tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "iSelect360CPCustomizePlanSection")
        tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "iSelect360CPCustomizePlan")
        tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "iSelect360CPCustomizePlanPremiumPaymentTerm")
      }
      console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "temp data")

      if (sectionState.sectionData[props.data.formControlKey] === "SG") {
        if (!(sectionState.sectionData["CPCustomizePlanPremiumPaymentTerm"] === "1" || sectionState.sectionData["iSelect360CPCustomizePlanPremiumPaymentTerm"] === "1")) {
          if (props.journeyIdFromStrapi === "iSelectJourney") {
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  ["CPCustomizePlanPremiumPaymentTerm"]: "1",
                }
              })
            })
          } else if (props.journeyIdFromStrapi === "ISelect360Journey") {
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  ["iSelect360CPCustomizePlanPremiumPaymentTerm"]: "1",
                }
              })
            })
          }
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
          console.log(temp, "iimp")

          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })

          props.saveApplicationAndCallBi("iSelect360CPCustomizePlanPremiumPaymentTerm", "1")
        }
      } else {
        if (props.journeyIdFromStrapi === "iSelectJourney") {
          if (sectionState.sectionData && sectionState.sectionData["CPCustomizePlanPremiumPaymentTerm"] && sectionState.sectionData["CPCustomizePlanPremiumPaymentTerm"] === "1") {
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  ["CPCustomizePlanPremiumPaymentTerm"]: sectionState.sectionData["CPCustomizePlanPolicyTerm"],
                }
              })
            })
            props.saveApplicationAndCallBi("CPCustomizePlanPremiumPaymentTerm", sectionState.sectionData["CPCustomizePlanPolicyTerm"])
          }
        } else if (props.journeyIdFromStrapi === "ISelect360Journey") {
          if (sectionState.sectionData && sectionState.sectionData["iSelect360CPCustomizePlanPremiumPaymentTerm"] && sectionState.sectionData["iSelect360CPCustomizePlanPremiumPaymentTerm"] === "1") {
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  ["iSelect360CPCustomizePlanPremiumPaymentTerm"]: sectionState.sectionData["iSelect360CPCustomizePlanPolicyTerm"],
                }
              })
            })
            props.saveApplicationAndCallBi("iSelect360CPCustomizePlanPremiumPaymentTerm", sectionState.sectionData["iSelect360CPCustomizePlanPolicyTerm"])
          }

        }
        let temp = journeyState.journeySteps
        console.log(temp, "dfg")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        console.log(temp, "iimp")
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
    }
    else if (props.sectionId === "CFSectionInvestmentDetails" && props.data.formControlKey === "CFPaymentFrequency") {

      //Temp Indexes will be used either in if or else
      let temp = journeyState.journeySteps
      let tempPageIndexToChange
      let tempSectionIndexToChange
      let tempComponentGroupIndexToChange
      let tempComponentIndexToChange
      if (props.journeyIdFromStrapi === "titaniumPlusJourney") {
        tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageTitaniumPlusCalculateFundValue")
        tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "CFSectionInvestmentDetails")
        tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "CFPremiumPaymentTerm")
        tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "CFPremiumPaymentTerm")
      }
      console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "temp data")

      if (!sectionState.sectionData["disabledForFrequency"] || (sectionState.sectionData["disabledForFrequency"] && sectionState.sectionData["disabledForFrequency"] === false)) {
        if (sectionState.sectionData[props.data.formControlKey] === "SG") {
          if (sectionState.sectionData["CFPremiumPaymentTerm"] !== "1") {
            if (props.journeyIdFromStrapi === "titaniumPlusJourney") {
              setSectionState(prev => {
                return ({
                  ...prev,
                  sectionData: {
                    ...prev.sectionData,
                    ["CFPremiumPaymentTerm"]: "1",
                    ["disabledForPPT"]: true
                  }
                })
              })
              props.saveApplicationAndCallBi("CFPremiumPaymentTerm", "1")
            }
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
            console.log(temp, "iimp")

            setJourneyState(prev => {
              return ({
                ...prev,
                journeySteps: temp
              })
            })
          }
        } else {
          if (sectionState.sectionData && sectionState.sectionData["CFPremiumPaymentTerm"] && sectionState.sectionData["CFPremiumPaymentTerm"] === "1") {
            let conditionStatePlanOptionKey = "PageTitaniumPlusCalculateFundValue.CFSectionInvestmentDetails.InvestmentPlanOption"
            let optionValues = journeyState.optionValues
            let premiumPaymentTermOptions
            if (sectionState.sectionData["CFpolicyTerm"]) {
              premiumPaymentTermOptions = optionValues?.[conditionState[conditionStatePlanOptionKey]]?.pptValues[sectionState.sectionData["CFpolicyTerm"]]
            }
            else {
              premiumPaymentTermOptions = journeyState.allUniquePptValues
            }
            let selectedOptionValue = Object.keys(premiumPaymentTermOptions)[1]
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  ["CFPremiumPaymentTerm"]: Object.keys(premiumPaymentTermOptions)[1],
                  ["disabledForPPT"]: false
                }
              })
            })
            props.saveApplicationAndCallBi("CFPremiumPaymentTerm", selectedOptionValue,)
          }
          let temp = journeyState.journeySteps
          console.log(temp, "dfg")
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
          console.log(temp, "iimp")
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }
      }
    }
    else if (props.sectionId === "CFSectionInvestmentDetails" && props.data.formControlKey === "CFPremiumPaymentTerm") {

      //Temp Indexes will be used either in if or else
      let temp = journeyState.journeySteps
      let tempPageIndexToChange
      let tempSectionIndexToChange
      let tempComponentGroupIndexToChange
      let tempComponentIndexToChange
      if (props.journeyIdFromStrapi === "titaniumPlusJourney") {
        tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageTitaniumPlusCalculateFundValue")
        tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "CFSectionInvestmentDetails")
        tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "CFPaymentFrequency")
        tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "CFPaymentFrequency")
      }
      console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "temp data")

      if (!sectionState.sectionData["disabledForPPT"] || (sectionState.sectionData["disabledForPPT"] && sectionState.sectionData["disabledForPPT"] === false)) {
        if (sectionState.sectionData[props.data.formControlKey] === "1") {
          if (sectionState.sectionData["CFPaymentFrequency"] !== "SG") {
            if (props.journeyIdFromStrapi === "titaniumPlusJourney") {
              setSectionState(prev => {
                return ({
                  ...prev,
                  sectionData: {
                    ...prev.sectionData,
                    ["CFPaymentFrequency"]: "SG",
                    ["disabledForFrequency"]: true
                  }
                })
              })
              props.saveApplicationAndCallBi("CFPaymentFrequency", "SG")
            }
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
            console.log(temp, "iimp")
            setJourneyState(prev => {
              return ({
                ...prev,
                journeySteps: temp
              })
            })
          }
        } else {
          if (sectionState.sectionData && sectionState.sectionData["CFPaymentFrequency"] && sectionState.sectionData["CFPaymentFrequency"] === "SG") {
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  ["CFPaymentFrequency"]: "01",
                  ["disabledForFrequency"]: false
                }
              })
            })
            console.log(temp, "iimp")
            setJourneyState(prev => {
              return ({
                ...prev,
                journeySteps: temp
              })
            })
          }
        }
      }
    }
    else if (props.sectionId === "FutureDollarGiftCityInvestmentDetailsSection" && props.data.formControlKey === "FutureDollarPaymentFrequency") {

      //Temp Indexes will be used either in if or else
      let temp = journeyState.journeySteps
      let tempPageIndexToChange
      let tempSectionIndexToChange
      let tempComponentGroupIndexToChange
      let tempComponentIndexToChange
      if (props.journeyIdFromStrapi === "FutureDollarGiftCityJourney") {
        tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFutureDollarGiftCityCalculateFundValue")
        tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "FutureDollarGiftCityInvestmentDetailsSection")
        tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "FutureDollarPPT")
        tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "FutureDollarPPT")
      }
      console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "temp data")

      // if (!sectionState.sectionData["disabledForFrequency"] || (sectionState.sectionData["disabledForFrequency"] && sectionState.sectionData["disabledForFrequency"] === false)) {
      //   if (sectionState.sectionData[props.data.formControlKey] === "SG") {
      //     if (sectionState.sectionData["FutureDollarPPT"] !== "1") {
      //       if (props.journeyIdFromStrapi === "FutureDollarGiftCityJourney") {
      //         setSectionState(prev => {
      //           return ({
      //             ...prev,
      //             sectionData: {
      //               ...prev.sectionData,
      //               ["FutureDollarPPT"]: "1",
      //               ["disabledForPPT"]: true
      //             }
      //           })
      //         })
      //         props.saveApplicationAndCallBi("FutureDollarPPT", "1")
      //       }
      //       temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
      //       console.log(temp, "iimp")

      //       setJourneyState(prev => {
      //         return ({
      //           ...prev,
      //           journeySteps: temp
      //         })
      //       })
      //     }
      //   } else {
      //     if (sectionState.sectionData && sectionState.sectionData["FutureDollarPPT"] && sectionState.sectionData["FutureDollarPPT"] === "1") {
      //       let conditionStatePlanOptionKey = "PageFutureDollarGiftCityCalculateFundValue.FutureDollarGiftCityInvestmentDetailsSection.FutureDollarInvestmentPlanOption"
      //       let optionValues = journeyState.optionValues
      //       let premiumPaymentTermOptions
      //       if (sectionState.sectionData["FutureDollarPT"]) {
      //         premiumPaymentTermOptions = optionValues?.[conditionState[conditionStatePlanOptionKey]]?.pptValues[sectionState.sectionData["FutureDollarPT"]]
      //       }
      //       else {
      //         premiumPaymentTermOptions = journeyState.allUniquePptValues
      //       }
      //       let selectedOptionValue = Object.keys(premiumPaymentTermOptions)[1]
      //       setSectionState(prev => {
      //         return ({
      //           ...prev,
      //           sectionData: {
      //             ...prev.sectionData,
      //             ["FutureDollarPPT"]: Object.keys(premiumPaymentTermOptions)[1],
      //             ["disabledForPPT"]: false
      //           }
      //         })
      //       })
      //       props.saveApplicationAndCallBi("FutureDollarPPT", selectedOptionValue,)
      //     }
      //     let temp = journeyState.journeySteps
      //     console.log(temp, "dfg")
      //     temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
      //     console.log(temp, "iimp")
      //     setJourneyState(prev => {
      //       return ({
      //         ...prev,
      //         journeySteps: temp
      //       })
      //     })
      //   }
      // }
    }
    else if (props.sectionId === "FutureDollarGiftCityInvestmentDetailsSection" && props.data.formControlKey === "FutureDollarPPT") {

      //Temp Indexes will be used either in if or else
      let temp = journeyState.journeySteps
      let tempPageIndexToChange
      let tempSectionIndexToChange
      let tempComponentGroupIndexToChange
      let tempComponentIndexToChange
      if (props.journeyIdFromStrapi === "FutureDollarGiftCityJourney") {
        tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFutureDollarGiftCityCalculateFundValue")
        tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "FutureDollarGiftCityInvestmentDetailsSection")
        tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "FutureDollarPaymentFrequency")
        tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "FutureDollarPaymentFrequency")
      }
      console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "temp data")

      if (!sectionState.sectionData["disabledForPPT"] || (sectionState.sectionData["disabledForPPT"] && sectionState.sectionData["disabledForPPT"] === false)) {
        if (sectionState.sectionData[props.data.formControlKey] === "1") {
          if (sectionState.sectionData["FutureDollarPaymentFrequency"] !== "SG") {
            // if (props.journeyIdFromStrapi === "FutureDollarGiftCityJourney") {
            //   setSectionState(prev => {
            //     return ({
            //       ...prev,
            //       sectionData: {
            //         ...prev.sectionData,
            //         ["FutureDollarPaymentFrequency"]: "SG",
            //         ["disabledForFrequency"]: true
            //       }
            //     })
            //   })
            //   props.saveApplicationAndCallBi("FutureDollarPaymentFrequency", "SG")
            // }
            // temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
            console.log(temp, "iimp")
            setJourneyState(prev => {
              return ({
                ...prev,
                journeySteps: temp
              })
            })
          }
        } else {
          if (sectionState.sectionData && sectionState.sectionData["FutureDollarPaymentFrequency"] && sectionState.sectionData["FutureDollarPaymentFrequency"] === "SG") {
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  ["FutureDollarPaymentFrequency"]: "12",
                  ["disabledForFrequency"]: false
                }
              })
            })
            props.saveApplicationAndCallBi("FutureDollarPaymentFrequency", "12")
            console.log(temp, "iimp")
            setJourneyState(prev => {
              return ({
                ...prev,
                journeySteps: temp
              })
            })
          }
        }
      }
    }
    else if (props.sectionId === "SectionInvest4GInvestmentDetails" && props.data.formControlKey === "invest4gPremiumFrequency") {

      //Temp Indexes will be used either in if or else
      let temp = journeyState.journeySteps
      let tempPageIndexToChange
      let tempSectionIndexToChange
      let tempComponentGroupIndexToChange
      let tempComponentIndexToChange
      if (props.journeyIdFromStrapi === "invest4GJourney") {
        tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageInvest4GCalculateFundValue")
        tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionInvest4GInvestmentDetails")
        tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "invest4GPPT")
        tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "invest4GPPT")
      }
      console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "temp data")

      if (!sectionState.sectionData["disabledForFrequency"] || (sectionState.sectionData["disabledForFrequency"] && sectionState.sectionData["disabledForFrequency"] === false)) {
        if (sectionState.sectionData[props.data.formControlKey] === "SG") {
          if (sectionState.sectionData["invest4GPPT"] !== "1") {
            if (props.journeyIdFromStrapi === "invest4GJourney") {
              setSectionState(prev => {
                return ({
                  ...prev,
                  sectionData: {
                    ...prev.sectionData,
                    ["invest4GPPT"]: "1",
                    ["disabledForPPT"]: true
                  }
                })
              })
            }
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
            console.log(temp, "iimp")

            setJourneyState(prev => {
              return ({
                ...prev,
                journeySteps: temp
              })
            })
          }
        } else {
          if (sectionState.sectionData && sectionState.sectionData["invest4GPPT"] && sectionState.sectionData["invest4GPPT"] === "1") {
            let conditionStatePlanOptionKey = "PageInvest4GCalculateFundValue.SectionInvest4GInvestmentDetails.Invest4gInvestmentPlanOption"
            let optionValues = journeyState.optionValues
            let premiumPaymentTermOptions
            if (sectionState.sectionData["invest4GPT"]) {
              premiumPaymentTermOptions = optionValues?.[conditionState[conditionStatePlanOptionKey]]?.pptValues[sectionState.sectionData["invest4GPT"]]
            }
            else {
              premiumPaymentTermOptions = journeyState.allUniquePptValues
            }
            let selectedOptionValue = Object.keys(premiumPaymentTermOptions)[1]
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  ["invest4GPPT"]: Object.keys(premiumPaymentTermOptions)[1],
                  ["disabledForPPT"]: false
                }
              })
            })
          }
          let temp = journeyState.journeySteps
          console.log(temp, "dfg")
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
          console.log(temp, "iimp")
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }
      }
    }
    else if (props.sectionId === "SectionInvest4GInvestmentDetails" && props.data.formControlKey === "invest4GPPT") {

      //Temp Indexes will be used either in if or else
      let temp = journeyState.journeySteps
      let tempPageIndexToChange
      let tempSectionIndexToChange
      let tempComponentGroupIndexToChange
      let tempComponentIndexToChange
      if (props.journeyIdFromStrapi === "invest4GJourney") {
        tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageInvest4GCalculateFundValue")
        tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionInvest4GInvestmentDetails")
        tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "invest4gPremiumFrequency")
        tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "invest4gPremiumFrequency")
      }
      console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "temp data")

      if (!sectionState.sectionData["disabledForPPT"] || (sectionState.sectionData["disabledForPPT"] && sectionState.sectionData["disabledForPPT"] === false)) {
        if (sectionState.sectionData[props.data.formControlKey] === "1") {
          if (sectionState.sectionData["invest4gPremiumFrequency"] !== "SG") {
            if (props.journeyIdFromStrapi === "invest4GJourney") {
              setSectionState(prev => {
                return ({
                  ...prev,
                  sectionData: {
                    ...prev.sectionData,
                    ["invest4gPremiumFrequency"]: "SG",
                    ["disabledForFrequency"]: true
                  }
                })
              })
              props.saveApplicationAndCallBi("invest4gPremiumFrequency", "SG")
            }
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
            console.log(temp, "iimp")
            setJourneyState(prev => {
              return ({
                ...prev,
                journeySteps: temp
              })
            })
          }
        } else {
          if (sectionState.sectionData && sectionState.sectionData["invest4gPremiumFrequency"] && sectionState.sectionData["invest4gPremiumFrequency"] === "SG") {
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  ["invest4gPremiumFrequency"]: "01",
                  ["disabledForFrequency"]: false
                }
              })
            })
            setConditionState(prev => {
              return {
                ...prev,
                [`${props.pageId}.${props.sectionId}.invest4gPremiumFrequency`]: "SG",
              }
            })
          }
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
          console.log(temp, "iimp")
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }
      } else {
        if (sectionState.sectionData && sectionState.sectionData["invest4gPremiumFrequency"] && sectionState.sectionData["invest4gPremiumFrequency"] === "SG"){
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["invest4gPremiumFrequency"]: "01",
                ["disabledForFrequency"]: false
              }
            })
          })
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.invest4gPremiumFrequency`]: "01",
            }
          })
          console.log(temp, "iimp")
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
             })
            })
          }
        }
      }
  }

  const invest4GsumAssuredValue = target => {
    let sumAssuredValue
    if(sectionState.sectionData?.["invest4gSumAssuredMultiplier"] && sectionState.sectionData?.["invest4gAmountInvest"] && sectionState.sectionData?.["invest4gPremiumFrequency"]){
       sumAssuredValue = (sectionState.sectionData?.["invest4gAmountInvest"] * sectionState.sectionData?.["invest4gSumAssuredMultiplier"])
    } else if(sectionState.sectionData?.["invest4gAmountInvest"] && sectionState.sectionData?.["invest4gPremiumFrequency"]){
      let frequency 
      if(sectionState.sectionData?.["invest4gPremiumFrequency"] === "12"){
        frequency = 1
      } else if(sectionState.sectionData?.["invest4gPremiumFrequency"] === "06"){
        frequency = 2
      }else if(sectionState.sectionData?.["invest4gPremiumFrequency"] === "01"){
        frequency = 12
      } else {
        frequency = 4
      }
      sumAssuredValue = (sectionState.sectionData?.["invest4gAmountInvest"] * frequency * 10)
    }
    setSectionState(prev => {
      return {
        ...prev,
        sectionData: {
          ...prev.sectionData,
          ["invest4gSumAssured"]: sumAssuredValue,
        },
      }
    })
    setConditionState(prev => {
      return {
        ...prev,
        [`${props.pageId}.${props.sectionId}.invest4gSumAssured`]: sumAssuredValue,
      }
    })
  }

  const handleChange = target => {
    if (sectionState.sectionId === props.sectionId) {
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: target.value,
          },
        }
      })
    } else {
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: props.sectionId,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: target.value,
          },
        }
      })
    }
    setConditionState(prev => {
      return {
        ...prev,
        [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: target.value,
      }
    })
    // console.log(conditionState, "dhdhdj")
    validate(target)
    if ((props.sectionId === "CPCustomizePlanSection" && props.data.formControlKey === "CPCustomizePlanPaymentFrequency") ||
      (props.sectionId === "iSelect360CPCustomizePlanSection" && props.data.formControlKey === "iSelect360CPCustomizePlanPaymentFrequency") ||
      (props.sectionId === "CFSectionInvestmentDetails" && props.data.formControlKey === "CFPaymentFrequency")
    ) {
      if (target.value !== "SG" &&
        ((props.journeyIdFromStrapi === "ISelect360Journey" && sectionState.sectionData["iSelect360CPCustomizePlanPremiumPaymentTerm"] !== "1")
          || (props.journeyIdFromStrapi === "iSelectJourney" && sectionState.sectionData["CPCustomizePlanPremiumPaymentTerm"] !== "1")
          || (props.journeyIdFromStrapi === "titaniumPlusJourney" && sectionState.sectionData["CFPremiumPaymentTerm"] !== "1"))) {
        props.saveApplicationAndCallBi(props.data.formControlKey, target.value)
      }
    } else if ((props.sectionId === "CFSectionInvestmentDetails" && props.data.formControlKey === "CFPremiumPaymentTerm")) {
      if (target.value !== "1" &&
        (props.journeyIdFromStrapi === "titaniumPlusJourney" && sectionState.sectionData["CFPaymentFrequency"] !== "SG")) {
        props.saveApplicationAndCallBi(props.data.formControlKey, target.value)
      }
    } else {
      props.saveApplicationAndCallBi(props.data.formControlKey, target.value)
    }

    // console.log(sectionState, "section state")
  }

  function getKeyByValue(object, value) {
    return object.find(key => key.value == value)
  }


  let optionsToShow
  if (props.data.formControlKey === "CFPaymentFrequency") {
    optionsToShow = props.options
    if (options[props.data.formControlKey]) {
      optionsToShow = Object.entries(optionsToShow).map(([key, val]) => ({
        value: key,
        label: val,
      }))
    }
  }
  else if (props.data.formControlKey === "FutureDollarPaymentFrequency") {
    optionsToShow = props.options
    if (options[props.data.formControlKey]) {
      optionsToShow = Object.entries(optionsToShow).map(([key, val]) => ({
        value: key,
        label: val,
      }))
    }
  }
  else {
    if (options[props.data.formControlKey]) {
      optionsToShow = Object.entries(options[props.data.formControlKey]).map(([key, val]) => ({
        value: key,
        label: val,
      }))
    }
  }

  if (
    props.pageId === "calculatePremiumPage" &&
    props.sectionId === "CPCustomizePlanSection" &&
    props.data.formControlKey === "CPCustomizePlanPaymentFrequency"
  ) {
    let conditionStatePlanOptionKey = "calculatePremiumPage.CPCustomizePlanSection.CPCustomizePlanQuestionOne"
    let policyTermKey = "CPCustomizePlanPolicyTerm"
    if (Object.keys(journeyState.optionValues).length) {
      let options = journeyState.optionValues?.[conditionState[conditionStatePlanOptionKey]]?.pptValues[sectionState.sectionData[policyTermKey]]
      if (options) {
        console.log(options, "OptionsAfterA60")
        let hasOneInPPT = Object.keys(options).some(key => {
          if (key === "1") {
            return true
          }
        })
        if (!hasOneInPPT) {
          optionsToShow = [
            {
              value: "12",
              label: "ANNUALLY"
            },
            {
              value: "01",
              label: "MONTHLY"
            },
            {
              value: "03",
              label: "QUARTERLY"
            },
            {
              value: "06",
              label: "SEMI-ANNUALLY"
            },
          ]
        }
      }
    }

  }

  if (
    props.pageId === "PageISelect360CalculatePremium" &&
    props.sectionId === "iSelect360CPCustomizePlanSection" &&
    props.data.formControlKey === "iSelect360CPCustomizePlanPaymentFrequency"
  ) {
    let conditionStatePlanOptionKey = "PageISelect360CalculatePremium.iSelect360CPCustomizePlanSection.iSelect360CPCustomizePlanQuestionOne"
    let policyTermKey = "iSelect360CPCustomizePlanPolicyTerm"
    if (Object.keys(journeyState.optionValues).length) {
      let options = journeyState.optionValues?.[conditionState[conditionStatePlanOptionKey]]?.pptValues[sectionState.sectionData[policyTermKey]]
      if (options) {
        console.log(options, "OptionsAfterA60")
        let hasOneInPPT = Object.keys(options).some(key => {
          if (key === "1") {
            return true
          }
        })
        if (!hasOneInPPT) {
          optionsToShow = [
            {
              value: "12",
              label: "ANNUALLY"
            },
            {
              value: "01",
              label: "MONTHLY"
            },
            {
              value: "03",
              label: "QUARTERLY"
            },
            {
              value: "06",
              label: "SEMI-ANNUALLY"
            },
          ]
        }
      }
    }
  }

  console.log(optionsToShow, "optionsToShow")

  return (
    <>
      {options[props.data.formControlKey] && Object.keys(options[props.data.formControlKey]).length >= 1 && <SelectContainer channel={props.channel} className={`input-container qw ${props.data.disabled ? 'disable-input' : ''} ${props.data.freeze ? 'freeze-input' : ''}`}>
        {
          options[props.data.formControlKey] && Object.keys(options[props.data.formControlKey]).length >= 1 &&
          <label htmlFor={props.data.label} className="input-label">
            {(getValueFromJourney(
              journeyState.lookup.label,
              props.data.label
            )) || props.data.label}
            {props.data.tooltip &&
              <span style={{ marginLeft: "10px" }} className="tooltip-col text-tool-tip-design existing-tool-tip">
                <div className="tool">i</div>
                <span className="tooltiptext4 tooltiptext5 tooltiptext4-align-list " style={{ width: "22rem", height: "fit-content", top: "auto", pointerEvents: "none" }}>
                  {Parser((getValueFromJourney(
                    journeyState.lookup.tooltip,
                    props.data.tooltip
                  )))}
                </span>
              </span>
            }
          </label>
        }
        {
          options[props.data.formControlKey] && Object.keys(options[props.data.formControlKey]).length >= 1 &&
          <Select
            // className="form-control"
            // styles={customStyles}
            options={optionsToShow}
            name={props.data.label}
            key={props.data.formControlKey}
            id="InputSelect"
            required={props.data.required}
            onChange={handleChange}
            // className={props.data.disabled?"disable-input":""}
            tabIndex={props.data.disabled || props.data?.freeze ? -1 : 0}

            value={
              sectionState.sectionData[props.data.formControlKey]
                ? getKeyByValue(
                  optionsToShow,
                  sectionState.sectionData[props.data.formControlKey]
                )
                : ""
            }
            onBlur={e => {validate(e.target)
              invest4GsumAssuredValue(e.target)}}
          ></Select>
        }
        {
          options[props.data.formControlKey] && Object.keys(options[props.data.formControlKey]).length >= 1 &&
          <span className="input-error2">
            {props.showError && errorState[props.data.formControlKey]}
          </span>
        }
      </SelectContainer>}
    </>
  )
}
